import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'app-feedback-success',
  standalone: true,
  templateUrl: './feedback-success.component.html',
  styleUrls: ['./feedback-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackSuccessComponent {
  confirmed = output<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }
}
